export default __webpack_public_path__ + "static/media/bc5b0cee68bbf00901142cd05d3a9114.3d29c470.jpeg";